module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-186.11befe9.woff2";